import React, { useEffect, useState } from 'react';
import { DOWNLOAD_FILE } from '../constants/aryRestCommands';
import useAryGetData, { aryGetDataExpectTypes } from '../hooks/useAryGetData';
import { getFileNameFromFileId, getImageSrc } from '../utils/Utils';
import AryDefaultProfileImage from './AryDefaultProfileImage';

const AryProfileIdToImage = ({ profileImageId, fullName, size = '32px' }) => {
  const [userProfile, setUserProfile] = useState();

  const [downloadFile] = useAryGetData(DOWNLOAD_FILE, {
    expect: aryGetDataExpectTypes.file
  });

  const getUserProfileFile = async () => {
    const newFileData = await downloadFile([
      {
        key: 'fileId',
        value: profileImageId
      }
    ]);
    const downloadedFile = new File(
      [newFileData],
      getFileNameFromFileId(profileImageId),
      {
        type: newFileData.type
      }
    );
    const imageProfile = await downloadedFile;
    return imageProfile;
  };

  useEffect(() => {
    if (profileImageId) {
      getUserProfileFile(profileImageId).then((data) => {
        setUserProfile(getImageSrc(data));
      });
    }
  }, [profileImageId]);

  return profileImageId ? (
    <img
      alt="profile"
      src={userProfile}
      loading="lazy"
      style={{
        borderRadius: '50%',
        width: size,
        height: size
      }}
    />
  ) : (
    <AryDefaultProfileImage
      size={size}
      fullName={fullName.replace(/\s/g, '').toUpperCase() || '-'}
    />
  );
};

export default AryProfileIdToImage;
